const { registerCheckoutFilters }  = window.wc.blocksCheckout;

const wcbpShowRemoveItemLink = ( defaultValue, extensions, args ) => {

	if ( extensions?.smart_product_bundle?.parent_bundle_id ) {
		return false;
	}
	return true;
};

const wcbpItemName = ( defaultValue, extensions, args ) => {

	if ( 'flat' == extensions?.smart_product_bundle?.item_grouping && extensions?.smart_product_bundle?.parent_bundle_id  ) {
		return `${args?.cart?.cartItems[0]?.name} → ${ defaultValue } <br>` + '<span class="block_part_of_bundle">part of bundle</span>';
	} else if('grouped' == extensions?.smart_product_bundle?.item_grouping && extensions?.smart_product_bundle?.parent_bundle_id) {
		return `${args?.cart?.cartItems[0]?.name} → ${ defaultValue } <br>` + '<span class="block_part_of_grouped"></span>';
	}
	if ( extensions?.smart_product_bundle?.edit_in_cart && args?.cartItem?.type == 'bundle_product' ) {
		var bundle_edit_link = args?.cartItem?.permalink + '?item_key=' + args?.cartItem?.key;
		return `${ defaultValue } <br> <a href="${bundle_edit_link}" class="bundle_edit_btn_in_cart"> →Edit</a>`;
	}
	return defaultValue;
};

const wcbpSaleBadgePriceFormat = ( defaultValue, extensions, args, validation ) => {	

	if ( extensions?.smart_product_bundle?.parent_bundle_id  || args?.cartItem?.type == 'bundle_product') {
		return '<price><price/>';
	}

	return '<price/>';
};

const wcbpSubtotalPriceFormat = ( defaultValue, extensions, args, validation ) => {

	if ( extensions?.smart_product_bundle?.parent_bundle_id  ) {
		if ( extensions?.smart_product_bundle?.product_price ) {
			return  '<price><price/>' + wc.priceFormat.formatPrice(extensions?.smart_product_bundle?.product_price);
		}
		return  '<price><price/>';
	}

	if ( args?.cartItem?.type == 'bundle_product' ) {
		return '<price><price/>' + wc.priceFormat.formatPrice(args?.cartItem?.prices?.price);
	}
	return '<price/>';
};

const wcbpCartItemClass = ( defaultValue, extensions, args ) => {

	if ( 'grouped' == extensions?.smart_product_bundle?.item_grouping && extensions?.smart_product_bundle?.parent_bundle_id ) {
		return 'wcbp-grouped-bundle-blocks';
	} else if ( 'flat' == extensions?.smart_product_bundle?.item_grouping && extensions?.smart_product_bundle?.parent_bundle_id ) {
		return 'wcbp-flat-bundle-blocks';
	}
	if ( args?.cartItem?.type == 'bundle_product' ) {
		return 'wcbp-parent-bundle-blocks';
	}

	return '';
};

registerCheckoutFilters( 'smart_product_bundle', {
	cartItemClass: wcbpCartItemClass,
	itemName: wcbpItemName,
	showRemoveItemLink: wcbpShowRemoveItemLink,
	saleBadgePriceFormat: wcbpSaleBadgePriceFormat,
	subtotalPriceFormat: wcbpSubtotalPriceFormat
});